import React, { FC } from 'react';
import { format } from "date-fns";
//utils
import { currencyFormatToBR } from "../../../../utils/numberFormatBR";
//models
import { ItemStockProps } from "models/Quote";
//assets
import priceHistoryIcon from "img/price-history-icon-inverted.svg";
//interface
import { ILastBudgetAndSale, IPriceHistoryModal } from './interface';
//styles
import { 
  CDGrid,
  CDItem,
  Column,
  CustomValue,
  Details,
  FactoryPrice,
  Header,
  HeaderTop,
  Row,
  SectionTitle,
  TextDetail,
  Title
} from './styles';

const PriceHistoryModal: FC<IPriceHistoryModal> = (props) => {
  const data = props.data;
  const lastBudget: ILastBudgetAndSale = data?.lastBudget || {};
  const lastSale: ILastBudgetAndSale = data?.lastSale || {};
  const itemStock = props.itemStock;
  const factoryPrice = itemStock?.find((x: ItemStockProps) => x)?.factoryPrice;

  const formatNumberAsString = (value: any, fractionDigits?: number) => {
    if (isNaN(value)) return '-';
    const formatted = currencyFormatToBR(value, fractionDigits);
    return 'R$ ' + formatted;
  };

  const CDListMinimumValues = itemStock.map((entry: any, index: number) => {
    const cd = entry.local;
    const minimumPrice = entry.minimumPriceLock1;
    return (
      <CDItem key={cd}>
        <div><span>{index + 1}º - </span>{cd}</div>
        <div>{formatNumberAsString(minimumPrice) || '-'}</div>
      </CDItem>
    );
  });

  return (
    <>
      <Header>
        <HeaderTop>
          <img className="historyImg" alt='price history icon' src={priceHistoryIcon} />
          <Title>HISTÓRICO <em>DE PREÇO</em></Title>
        </HeaderTop>

        <FactoryPrice>
          <div className="line" />
          <div className="price-info">
            <strong>Preço Fábrica</strong>
            <span>{formatNumberAsString(factoryPrice)}</span>
          </div>
        </FactoryPrice>
      </Header>

      <SectionTitle>Preço mín. por CD</SectionTitle>
      <CDGrid>{CDListMinimumValues}</CDGrid>

      <Details>
        <Row>
          <Column>
            <TextDetail faded>Tipo</TextDetail>
            <CustomValue textValue>Último orçado</CustomValue>
            <CustomValue textValue>Último faturado</CustomValue>
          </Column>
          <Column>
            <TextDetail faded>Valor unitário</TextDetail>
            <CustomValue>{lastBudget?.price ? formatNumberAsString(lastBudget?.price) : '-'}</CustomValue>
            <CustomValue>{lastSale?.price ? formatNumberAsString(lastSale?.price) : '-'}</CustomValue>
          </Column>
          <Column>
            <TextDetail faded>Data</TextDetail>
            <CustomValue>{lastBudget?.date ? format(new Date(lastBudget?.date), 'dd/MM/yyyy') : '-'}</CustomValue>
            <CustomValue>{lastSale?.date ? format(new Date(lastSale?.date), 'dd/MM/yyyy') : '-'}</CustomValue>
          </Column>
          <Column>
            <TextDetail faded>CD</TextDetail>
            <CustomValue>{lastBudget?.distributionCenter || '-'}</CustomValue>
            <CustomValue>{lastSale?.distributionCenter || '-'}</CustomValue>
          </Column>
        </Row>
      </Details>
    </>
  );
};

export default PriceHistoryModal;